import {
  Sparkle, Trophy, ChartBar, Crosshair, TrendUp,
  NotePencil, CurrencyDollar, UserCircle, House, X, Globe, ChatCircleDots, BookOpen, Newspaper, Briefcase, Megaphone, Storefront,
} from "@phosphor-icons/react";

// Full-screen right-side menu drawer shown only on mobile (lg:hidden). Lists
// the two product families + account links, mirroring the desktop grouped nav.
const MobileMenuDrawer = ({ open, onClose, user, activeTab, setActiveTab, openAuth }) => {
  if (!open) return null;

  const groups = [
    { group: "Research", items: [
      { label: "Advisor", tab: "copilot", icon: ChatCircleDots },
      { label: "Guide & Demo", tab: "guide", icon: BookOpen },
    ] },
    { group: "Proven Winners", items: [
      { label: "Discover", tab: "discover", icon: Sparkle },
      { label: "Evaluate", tab: "evaluate", icon: Trophy },
    ] },
    { group: "Demand Signals", items: [
      { label: "Dashboard", tab: "dashboard", icon: ChartBar },
      { label: "Signals", tab: "opportunities", icon: Crosshair },
      { label: "Pain Points", tab: "pain_points", icon: Megaphone },
      { label: "AI Pulse", tab: "ai_pulse", icon: Sparkle },
      { label: "Trending", tab: "trending", icon: TrendUp },
      { label: "Best Country", tab: "country_fit", icon: Globe },
      { label: "Weekly Reports", tab: "reports", icon: Newspaper },
      { label: "YC Jobs", tab: "jobs", icon: Briefcase },
    ] },
    { group: "Commerce", items: [
      { label: "Commerce Intelligence", tab: "commerce", icon: Storefront },
    ] },
    { group: "Your account", items: [
      { label: "My Briefs", tab: "briefs", icon: NotePencil },
      { label: "Pricing", tab: "pricing", icon: CurrencyDollar },
      ...(user ? [{ label: "Account", tab: "account", icon: UserCircle }] : []),
      { label: "Home", tab: "landing", icon: House },
    ] },
  ];

  return (
    <div className="lg:hidden fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm" onClick={onClose} data-testid="mobile-menu-overlay">
      <div className="absolute inset-y-0 right-0 w-[88%] max-w-sm bg-white shadow-2xl flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 h-14 border-b border-zinc-200 flex-shrink-0">
          <span className="font-semibold text-zinc-900">Menu</span>
          <button onClick={onClose} className="-mr-2 min-h-[44px] min-w-[44px] flex items-center justify-center text-zinc-500" data-testid="mobile-menu-close" aria-label="Close menu">
            <X size={22} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-3 py-4 space-y-6">
          {groups.map((g) => (
            <div key={g.group}>
              <div className="px-3 mb-1.5 text-[10px] font-mono-data uppercase tracking-[0.18em] text-zinc-400">{g.group}</div>
              <div className="space-y-0.5">
                {g.items.map((it) => {
                  const Icon = it.icon;
                  const active = activeTab === it.tab;
                  return (
                    <button key={it.label} onClick={() => { setActiveTab(it.tab); onClose(); }} data-testid={`mobile-menu-${it.tab}`}
                      className={`w-full flex items-center gap-3 px-3 min-h-[48px] rounded-xl text-[15px] font-medium transition-colors ${active ? "bg-violet-600/10 text-violet-700" : "text-zinc-700 hover:bg-zinc-50"}`}>
                      <Icon size={20} weight="duotone" /> {it.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          {!user && (
            <button onClick={() => { onClose(); openAuth("login"); }} className="w-full px-4 min-h-[48px] rounded-xl text-sm font-semibold text-white bg-violet-600" data-testid="mobile-menu-login">
              Get started
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenuDrawer;
